import {GetCategoryInitialDataQuery, GetCategoryInitialDataWithCategoryDataQuery} from '../graphql/queries-schema';

type CategoryListItem = GetCategoryInitialDataWithCategoryDataQuery['catalog']['categories']['list'][0];
type Category = GetCategoryInitialDataWithCategoryDataQuery['catalog']['category'];

export interface ICategoryListItem extends CategoryListItem {
  categoryUrl?: string;
}
export interface ICategory extends Category {
  categoryUrl?: string;
}

interface IRouterBreadcrumb {
  categoryId?: string;
  categoryName?: string;
  categorySlug?: string;
}

export function isEnrichedRouterCategory(
  category: ICategory | IEnrichedRouterCategory
): category is IEnrichedRouterCategory {
  return 'breadcrumbsInfo' in category;
}

export interface IRouterCategory {
  id: string;
  name: string;
  slug: string;
  visible: boolean;
  description?: string | null;
  numOfProducts?: number;
  media?: {
    url?: string;
    fullUrl?: string;
    mediaType?: string;
    width?: number;
    height?: number;
  } | null;
  parentCategoryId?: string | null;
  parentCategoryIndex?: number | null;
  seoData?: string | null;
  breadcrumbsInfo?: {
    breadcrumbs: IRouterBreadcrumb[];
  };
}

export interface IEnrichedRouterCategory extends IRouterCategory {
  richContentDescription?: GetCategoryInitialDataQuery['catalog']['category']['richContentDescription'];
}
